import { DateTime } from 'luxon';

export const calculateDhulHijjahDonations = ({
  startDate,
  timeZone,
  selectedProducts,
  currency,
  processingTime = '12:00',
  donationOption,
  selectedConditions = [],
  multipliers,
  numberOfNights
}) => {
  const totalExact = selectedProducts.reduce((sum, p) => {
    const price = p[currency.toLowerCase()] || 0;
    return sum + price * (p.quantity || 0);
  }, 0);
  const totalRounded = Math.round(totalExact);

  const startLuxon = DateTime.fromJSDate(startDate).setZone(timeZone).startOf('day');
  const now = DateTime.now().setZone(timeZone);
  const today = now.startOf('day');
  const isAfter1030AM = now.hour > 10 || (now.hour === 10 && now.minute >= 30);

  const provisionalEnd = startLuxon.plus({ days: 9 });
  const hijjahEnd = DateTime.fromObject({ year: startLuxon.year, month: 6, day: 8 }, { zone: timeZone }).startOf('day');
  const finalEnd = provisionalEnd <= hijjahEnd ? provisionalEnd : hijjahEnd;

  const allDates = [];
  for (let d = startLuxon; d <= finalEnd; d = d.plus({ days: 1 })) {
    allDates.push(d);
  }

  const effectiveStart = (today > startLuxon || (today.equals(startLuxon) && isAfter1030AM)) ? today.plus({ days: 1 }) : today;
  const donationDates = allDates.filter(d => d >= effectiveStart).slice(0, 10);

  if (donationDates.length === 0) {
    return {
      donationSchedule: [],
      summary: { totalAmount: 0, totalDays: 0, dailyAmount: 0 }
    };
  }

  // -----------------------
  // SHARE CALCULATION
  // -----------------------
  let dayShares = donationDates.map(d => {
    let share = 0;
    if (donationOption === 'custom') {
      if (selectedConditions.includes('friday') && d.weekday === 5) {
        share += multipliers.friday || 1;
      }

      if (selectedConditions.includes('arrafahDay')) {
        const isArrafahDay = d.toISODate() === donationDates[donationDates.length - 2].toISODate();
        if (isArrafahDay) {
          share += multipliers.arrafahDay || 1;
        }
      }
      if (selectedConditions.includes('qurbanDay')) {
        const isQurbanDay = d.toISODate() === donationDates[donationDates.length - 1].toISODate();
        if (isQurbanDay) {
          share += multipliers.qurbanDay || 1;
        }
      }
    }

    if (donationOption === 'equal' || share === 0) {
      share = 1;
    }

    return share;
  });

  const totalShares = dayShares.reduce((sum, s) => sum + s, 0);
  const shareValue = totalRounded / totalShares;
  // console.log("day share=",numberOfNights,donationOption,totalShares,shareValue,dayShares, multipliers)

  const schedule = donationDates.map((d, idx) => ({
    date: d.toISODate(),
    shares: dayShares[idx],
    amount: Math.round(dayShares[idx] * shareValue),
    isMultiplierNight: dayShares[idx] > 1,
  }));

  // Fix rounding drift
  let diff = totalRounded - schedule.reduce((s, d) => s + d.amount, 0);
  for (let i = 0; diff !== 0; i = (i + 1) % schedule.length) {
    if (schedule[i].shares === 1 || schedule[i].shares > 0) {
      schedule[i].amount += diff > 0 ? 1 : -1;
      diff += diff > 0 ? -1 : 1;
    }
  }

  // -----------------------
  // ALLOCATE PRODUCTS
  // -----------------------
  const handleAddPrd = () => {
    const tempSchedule = JSON.parse(JSON.stringify(schedule));
    let totalBase = 0;
    selectedProducts.forEach(p => {
      totalBase += p.quantity * (p[currency.toLowerCase()] || 0);
    });

    const withPct = selectedProducts.map(p => {
      const base = p.quantity * (p[currency.toLowerCase()] || 0);
      return { product: p, pct: totalBase ? (base * 100) / totalBase : 0 };
    });

    const scheduleWithProd = tempSchedule
      .filter(d => d.amount > 0)
      .map(d => {
        const alloc = withPct.map(item => {
          const raw = (d.amount * item.pct) / 100;
          return { product: { ...item.product }, qty: Math.round(raw) };
        });

        // let diff = d.amount - alloc.reduce((s, a) => s + a.qty, 0);
        // for (let i = 0; diff !== 0; i = (i + 1) % alloc.length) {
        //   if (diff > 0) {
        //     alloc[i].qty++;
        //     diff--;
        //   } else if (diff < 0 && alloc[i].qty > 0) {
        //     alloc[i].qty--;
        //     diff++;
        //   }
        // }

        let diff = d.amount - alloc.reduce((s, a) => s + a.qty, 0);
        let safeGuard = 0; // to avoid infinite loop

        while (diff !== 0 && safeGuard < 1000) {
          for (let i = 0; i < alloc.length && diff !== 0; i++) {
            if (diff > 0) {
              alloc[i].qty++;
              diff--;
            } else if (diff < 0 && alloc[i].qty > 1) {
              // ensure we don’t drop it to 0 if it was meant to have share
              alloc[i].qty--;
              diff++;
            }
          }
          safeGuard++;
        }

        alloc.forEach(a => (a.product.quantity = a.qty));
        return { ...d, products: alloc.map(a => a.product), currency, timeZone, processingTime };
      });

    localStorage.setItem('DHULHIJJAH_DONATION', JSON.stringify(scheduleWithProd));
  };

  handleAddPrd();

  return {
    donationSchedule: schedule,
    summary: {
      totalAmount: schedule.reduce((sum, d) => sum + d.amount, 0),
      totalDays: donationDates.length,
      dailyAmount: totalRounded / donationDates.length,
    }
  };
};
